module.exports = __webpack_public_path__ + "images/5c55f0b236157739326cb4c8d0da536e5.svg";